/**
 * Badge Component
 * Status badges with different variants
 */
export default function Badge({ children, variant = 'gray', className = '' }) {
  const variants = {
    success: 'badge-success',
    warning: 'badge-warning',
    danger: 'badge-danger',
    info: 'badge-info',
    gray: 'badge-gray',
    primary: 'badge-primary',
  }
  
  return (
    <span className={`badge ${variants[variant]} ${className}`}>
      {children}
    </span>
  )
}